import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

const RedirectMessage: React.FC = () => {
  const {t} = useTranslation();
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = '/';
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <h1>{t('heading_error')}</h1>
      <p>{t('homepage_redirect_message')}</p>
    </>
  );
};

export default RedirectMessage;
